import { Box, Grid, Typography, Table, TableContainer, TableHead, TableCell, TableRow, TableBody, Button, Tooltip, Stack, Switch } from "@mui/material";
import { useForm } from "react-hook-form";
import CameraCapture from "../../../components/webCam/CaptureImage";
import { AddCircle, Edit } from "@mui/icons-material";
import { ControlledInput } from "../../../components/forms/input/ControlledInput";
import TableImage from "../../../components/table/TableImage";
import { useEffect, useState } from "react";
import { useCrudForm } from "../../../api/useCrudForm";
import { endpoints } from "../../../api/endpoints";
import CustomSelect from "../../../components/forms/select/CustomSelect";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { LoadingButton } from "@mui/lab";

type NomineeDetailsAndBiometricsPropType = {
    children: any,
    setPage: (value: any) => void
}

const NomineeDetailsAndBiometrics = ({ children, setPage }: NomineeDetailsAndBiometricsPropType) => {
    const [imageUrl, setImageUrl] = useState<any>()
    const [fields, setFields] = useState<any>([]);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [relationshipList, setRelationshipList] = useState<any>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { id } = useParams()
    const location = useLocation();
    const navigate = useNavigate()
    const queryParams = new URLSearchParams(location.search);
    const isMainTable = queryParams.get('isMainTable') ?? false;

    const tableHeadData = ['Nominee Name', 'Address', 'Relationship', 'Citizenship no.', 'Mobile no.', 'email', 'Photo', 'isActive', 'Action']
    const initialValues = { id: null, customerId: Number(id), firstName: "", middleName: "", lastName: "", address: "", relationshipId: "", nomineeRelationshipName: "", mobileNumber: "", email: "", citizenshipNumber: '', photoUrl: "", othersRelationship: '', isActive: true }

    const { add, edit, get } = useCrudForm()

    const { handleSubmit, control, formState: { errors, }, setValue, reset } = useForm(
        {
            resolver: yupResolver(NomineePersonalDetailSchema),
            defaultValues: initialValues
        }
    )

    useEffect(() => {
        get({
            endpoints: `${endpoints.common.getRelationships}`,
            onSuccess: (res: any) => {
                setRelationshipList(res.data)
            },
            onError: (error: any) => {
                console.log(error);
            }
        })
        get({
            endpoints: `${endpoints.nomineeInformation.api}/${id}?isMainTable=${isMainTable}`,
            onSuccess: (res: any) => {
                setFields(res.data)
                if (res.data.length > 0) {
                    setIsEdit(true)
                }
            },
            onError: (error: any) => {
                console.log(error);
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const ondataSubmit = (data: any) => {
        if (data.id === null) {
            delete data.id
            setFields((prevFields: any) => [...prevFields, data])
        } else {
            const updatedFields = fields.map((field: any) => {
                if (field.id === data.id) {
                    return data;
                }
                return field;
            });
            setFields(updatedFields);
        }
        reset()
        setImageUrl(undefined)
    };

    const onSubmit = () => {
        setIsLoading(true)
        add({
            endpoints: `${endpoints.nomineeInformation.api}?isMainTable=${isMainTable}`,
            onSuccess: (data: any) => {
                setPage('one')
                window.scrollTo(0, 0)
                setIsLoading(false)
                toast.success(data.message, { style: { background: '#3150A1' } })
                navigate(`/customers/new-registration/${data.data}?isMainTable=false`)
            },
            onError: (error: any) => {
                toast.error(error);
                setIsLoading(false)
            },
            values: fields
        })
    }

    const updateNominee = () => {
        setIsLoading(true)
        edit({
            values: fields,
            endpoints: `${endpoints.nomineeInformation.api}?isMainTable=${isMainTable}`,
            onSuccess: (res: any) => {
                setPage('one')
                window.scrollTo(0, 0)
                setIsLoading(false)
                toast.success(res.message, { style: { background: '#3150A1' } })
                navigate(`/customers/new-registration/${res.data}?isMainTable=false`)
            },
            onError: (error: any) => {
                toast.error(error)
                setIsLoading(false)
            }
        })
    }

    const EditNomineeDetails = (selectedData: any, index: number) => {
        setImageUrl(selectedData.photoUrl)
        setValue("id", selectedData.id);
        setValue("firstName", selectedData.firstName);
        setValue("middleName", selectedData.middleName);
        setValue("lastName", selectedData.lastName);
        setValue("address", selectedData.address);
        setValue("relationshipId", selectedData.relationshipId);
        setValue("nomineeRelationshipName", selectedData.nomineeRelationshipName);
        setValue("citizenshipNumber", selectedData.citizenshipNumber);
        setValue("mobileNumber", selectedData.mobileNumber);
        setValue("email", selectedData.email);
        setValue("photoUrl", selectedData.photoUrl);
        setValue("isActive", selectedData.isActive);
    }

    const handleSwitchChange = (index: number) => {
        setFields((prevFields: any) => {
            const updatedFields = [...prevFields];
            updatedFields[index].isActive = !updatedFields[index].isActive;
            return updatedFields;
        });
    };

    return (
        <Box>
            <Typography sx={{ color: "black", fontSize: "20px", fontWeight: "700" }} mb={2}>
                Nominee Details
            </Typography>
            <Box sx={{ marginBottom: '50px' }}>
                <Box sx={{ display: "flex", gap: '50px' }}>
                    <Box>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <ControlledInput name="firstName" control={control} errors={errors} label="First name" />
                            </Grid>
                            <Grid item xs={6}>
                                <ControlledInput name="middleName" control={control} errors={errors} label="Middle name" />
                            </Grid>
                            <Grid item xs={6}>
                                <ControlledInput name="lastName" control={control} errors={errors} label="Last name" />
                            </Grid>
                            <Grid item xs={6}>
                                <ControlledInput name="address" control={control} errors={errors} label="Address" />
                            </Grid>
                            <Grid item xs={6}>
                                <CustomSelect
                                    label="Relationship"
                                    name="relationshipId"
                                    errors={errors?.relationshipId?.message}
                                    control={control}
                                    values={relationshipList}
                                    size={12}
                                    isEnum={true}
                                    labelName="nomineeRelationshipName"
                                    setValue={setValue}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <ControlledInput name="citizenshipNumber" control={control} errors={errors} label="Citizenship No." />
                            </Grid>
                            <Grid item xs={6}>
                                <ControlledInput type="number" name="mobileNumber" control={control} errors={errors} label="Mobile No." />
                            </Grid>
                            <Grid item xs={6}>
                                <ControlledInput name="email" control={control} errors={errors} label="Email" />
                            </Grid>
                        </Grid>
                    </Box>
                    <Box sx={{ borderRadius: '20px', display: 'flex', justifyContent: "center", alignItems: 'center' }}>
                        <CameraCapture isNominee={true} boxSize={'300px'} smallImageSize={true} setValue={setValue} setImageUrl={setImageUrl} imageUrl={imageUrl} />
                    </Box>
                </Box>
                <Button onClick={() => handleSubmit(ondataSubmit)()} variant="contained" sx={{ textTransform: 'capitalize', marginTop: '20px', backgroundColor: '#22bd4b', display: 'flex', justifyItems: 'center', alignItems: 'center', gap: '5px', '&:hover': { backgroundColor: '#167530' } }}><AddCircle sx={{ width: '20px' }} /> Add Nominee</Button>
            </Box>
            {fields.length > 0 && <Box>
                <TableContainer sx={{ border: '1px solid #e7e7e7', borderRadius: '5px' }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {
                                    tableHeadData.map((tableHeader: any, index: number) => (
                                        <TableCell key={index}>
                                            <Typography sx={{ fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>{tableHeader}</Typography>
                                        </TableCell>
                                    ))
                                }

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {fields && fields.map((row: any, index: number) => (
                                <TableRow key={index}
                                    sx={{
                                        "&:last-child td, &:last-child th": {
                                            border: 0,
                                        },
                                    }}
                                >
                                    <TableCell>{row.firstName} {row.middleName} {row.lastName}</TableCell>
                                    <TableCell>{row.address}</TableCell>
                                    <TableCell>{row.nomineeRelationshipName}</TableCell>
                                    <TableCell>{row.citizenshipNumber}</TableCell>
                                    <TableCell>{row.mobileNumber}</TableCell>
                                    <TableCell>{row.email}</TableCell>
                                    <TableCell><TableImage value={row.photoUrl} /></TableCell>
                                    <TableCell>
                                        <Switch
                                            checked={row.isActive}
                                            onChange={() => handleSwitchChange(index)}
                                        />
                                    </TableCell>
                                    <TableCell align="center" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                                        {row.isActive ? <Tooltip title="Edit customer" >
                                            <Edit sx={{ width: '30px', height: '30px', backgroundColor: '#32CD33', borderRadius: '100%', padding: '6px', color: 'white' }} onClick={() => EditNomineeDetails(row, index)} />
                                        </Tooltip> : <Typography sx={{ fontStyle: 'italic', fontSize: '14px', color: 'gray' }}>No action available</Typography>}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>}
            {fields.length > 0 && <Stack direction="row" spacing={2} sx={{ justifyContent: "end", marginTop: "24px" }}>
                <LoadingButton loading={isLoading} onClick={() => { isEdit ? updateNominee() : onSubmit() }} variant="contained" sx={{ textTransform: 'capitalize', marginTop: '20px', backgroundColor: '#3150A1', display: 'flex', justifyItems: 'center', alignItems: 'center', gap: '5px', '&:hover': { backgroundColor: '#167530' } }}>
                    <Typography sx={{ textTransform: "capitalize", fontSize: "14px" }}>{isEdit ? 'Update' : 'Submit'}</Typography>
                </LoadingButton>
            </Stack>}

        </Box >
    )
}
export default NomineeDetailsAndBiometrics;

const NomineePersonalDetailSchema = yup.object().shape({
    firstName: yup.string().required("Firstname required"),
    lastName: yup.string().required("Lastname required"),
    address: yup.string().required("Address required"),
    relationshipId: yup.number().typeError('Relationship required').required("Relationship required").notOneOf([0], "Relationship required"),
    citizenshipNumber: yup.string().required("Citizenship no required"),
    mobileNumber: yup.string().required("Mobile no required"),
    email: yup.string().email().nullable()
});